import dayjs from "dayjs";
import {convertCurrentDateToUserTimeZone} from "./utils";
import {emailValidError, nameMaxLengthError, requiredFieldError} from "../../components/PortalUsers/utils";
import * as Yup from 'yup';
import i18n from "../../services/i18n";
import {notPastDateTest} from "../../utils/notPastDateTest";


export const CreateNewPortalUserValidationSchema = (config:any) => {

const notPastActivationOrExpirationDate = notPastDateTest(
    'errors:portalUsers.activationDate',
    (ctx) => dayjs(convertCurrentDateToUserTimeZone(ctx.parent.timezone)),
    (_value, ctx) =>
        dayjs(convertCurrentDateToUserTimeZone(ctx.parent.timezone))
            .startOf('date')
            .format('YYYY-MM-DD'),
);

return Yup.object().shape({
    role: Yup.string().required(requiredFieldError).nullable(),
    password: Yup.string()
        .test(
            'passLength',
            i18n.t<string>('enums:passwordRules.PasswordMinLength', {
                charLength: config?.Web.PasswordMinLength,
            }),
            function (value?: string) {
                if (
                    value !== undefined &&
                    config?.Web.PasswordMinLength
                ) {
                    return (
                        value.length >=
                        config?.Web.PasswordMinLength
                    );
                }

                return true;
            },
        )
        .test(
            'passContainLetters',
            i18n.t<string>('enums:passwordRules.cr'),
            function (value?: string) {
                if (
                    value !== undefined &&
                    config?.Web.PasswordComplexityRules
                ) {
                    return /[a-zA-Z]/g.test(value);
                }

                return true;
            },
        )
        .test(
            'passContainLetters',
            i18n.t<string>('enums:passwordRules.nr'),
            function (value?: string) {
                if (
                    value !== undefined &&
                    config?.Web.PasswordComplexityRules
                ) {
                    return /\d/.test(value);
                }

                return true;
            },
        )
        .max(32, nameMaxLengthError)
        .required(requiredFieldError),
    login: Yup.string()
        .matches(
            /(^[A-Za-z0-9-_@.]*$)/,
            i18n.t<string>('errors:portalUsers.portalRegex'),
        )
        .required(requiredFieldError),
    email: Yup.string().email(emailValidError).notRequired(),
    activationDate: Yup.string()
        .test('past', notPastActivationOrExpirationDate)
        .nullable(),
    expirationDate: Yup.string()
        .test('past', notPastActivationOrExpirationDate)
        .test(
            'dobY',
            i18n.t<string>('errors:portalUsers.expirationDateAfterActivation'),
            (value, ctx) => {
                const expired = value
                    ? dayjs(value, 'YYYY-MM-DD').toDate()
                    : null;
                const activation = Yup.ref('activationDate')
                    ? dayjs(
                        ctx.parent.activationDate,
                        'YYYY-MM-DD',
                    ).toDate()
                    : null;

                if (!expired || !activation || !ctx.parent.activationDate) {
                    return true;
                }

                return activation < expired;
            },
        )
        .nullable()
        .notRequired(),
});


}